import { createFileRoute } from "@tanstack/react-router";
import { CityPageBody } from "@/components/site/CityPageBody";
import { BUSINESS } from "@/components/site/constants";
import { canonical } from "@/components/site/site-config";

export const Route = createFileRoute("/roofing-company-citrus-springs-fl")({
  head: () => ({
    meta: [
      { title: "Roofing Company in Citrus Springs, FL | Destination Roofing" },
      { name: "description", content: `Local roofing company serving Citrus Springs, FL. Roof repair, replacement, shingle and metal roofing. Free Roof Inspection & Estimate. Call ${BUSINESS.phone}.` },
      { property: "og:title", content: "Roofing Company in Citrus Springs, FL" },
      { property: "og:description", content: "Family-owned roofer serving Citrus Springs, FL." },
      { property: "og:url", content: canonical("/roofing-company-citrus-springs-fl") },
    ],
    links: [{ rel: "canonical", href: canonical("/roofing-company-citrus-springs-fl") }],
  }),
  component: () => (
    <CityPageBody
      city="Citrus Springs"
      intro={
        <p>
          Citrus Springs is a large residential community with hundreds of single-family homes built from the 70s through today. The roof mix is heavy asphalt shingle with a growing number of homeowners switching to metal for storm resilience and lower long-term maintenance.
        </p>
      }
      localNotes={
        <>
          <p>
            The wide open lot layout in Citrus Springs means most roofs get direct Florida sun all day. We often see accelerated shingle aging, brittle flashings, and heat-cured sealants that no longer keep water out. Wind mitigation upgrades on newer replacements are a common request here — ask your insurance carrier whether documented improvements may help you qualify for credits on your policy.
          </p>
          <p>
            If your Citrus Springs home is on its original roof and it's more than 18 years old, a Free Roof Inspection will tell you where it stands.
          </p>
        </>
      }
    />
  ),
});
